import springApi from '../../services/springApi'

export const getProductQuotes = params => (
	new Promise((resolve, reject) => {
		springApi()
			.get('/product_quote', { params })
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)